import React from 'react';
import Tabs from './Tabs';

function Layout(props) {

   return (
      <div>
        <Tabs {...props}/>
        <div>
         {props.children}
        </div>
      </div>
    );
  }
  
  export default Layout;